import React from 'react';
import styled from 'styled-components/macro';
import { FormattedMessage } from 'react-intl';

import { useExpandContent } from './';
import messages from './messages';

import { ReactComponent as Opened } from '@/icons/ic-collapse-menu-opened.svg';
import { ReactComponent as Closed } from '@/icons/ic-collapse-menu-closed.svg';

const OpenedIcon = styled(Opened)`
  margin-right: 8px;
`;

const ClosedIcon = styled(Closed)`
  margin-right: 8px;
`;

const ExpandContentWrapper = styled.div`
  width: 100%;
`;

const ExpandContentToggleWrapper = styled.div`
  padding-top: 12px;
`;

const ExpandContentToggle = styled.div`
  cursor: pointer;
  display: inline-block;
  color: #1a8bde;
  font-size: 14px;
  white-space: nowrap;
  &::after {
    display: block;
    content: '';
    height: 4px;
    width: 100%;
    border-bottom: 1px solid currentColor;
  }
`;

const ExpandContentChildren = styled.div``;

export function ExpandContent({
  isExpanded,
  openedText,
  closedText,
  children,
}) {
  const [isOpened, toggleIsOpen] = useExpandContent(isExpanded);

  return (
    <ExpandContentWrapper data-testid="expand-content">
      {isOpened && <ExpandContentChildren>{children}</ExpandContentChildren>}
      <ExpandContentToggleWrapper
        data-testid="expand-content__click"
        onClick={toggleIsOpen}
      >
        {isOpened ? (
          <ExpandContentToggle>
            <OpenedIcon />
            {openedText}
          </ExpandContentToggle>
        ) : (
          <ExpandContentToggle>
            <ClosedIcon />
            {closedText}
          </ExpandContentToggle>
        )}
      </ExpandContentToggleWrapper>
    </ExpandContentWrapper>
  );
}

ExpandContent.defaultProps = {
  isExpanded: false,
  openedText: <FormattedMessage {...messages.opened} />,
  closedText: <FormattedMessage {...messages.closed} />,
};
